const SendChatInputIcon = ({ isSendActive }) => {
  const basePath = `${window.location.origin}/images`;
  return (
    <img
      src={
        isSendActive
          ? `${basePath}/sent-icon.png`
          : `${basePath}/sent-icon-default.png`
      }
      alt="Image Indicator"
      style={{ width: 21, height: 21 }}
    />
  );
};

export default SendChatInputIcon;

